export function getFixtureByTeamId(fixtures, teamId) {
  return fixtures.find((fixture) =>
    fixture.teams.some(
      (team) => team.team.id === teamId || team.opponent.id === teamId,
    ),
  );
}

export function getOpponentFromFixture(fixture, teamId) {
  if (fixture === null) return null;

  return fixture.teams.find((team) => team.team.id !== teamId) || null;
}
